import { SCAN_CHECKPOINT_LIST, TESTDRIVE_RIDE_ID, ALL_SCAN_CHECKPOINT_LIST, GPT_SCAN_CHECKPOINT_RESPONECE, GPT_ERROR_TOAST, GPT_MESSAGE_TOAST, ALL_SCAN_CHECK_POINT_TOAST, TEST_DRIVE_COMPLECT, TEST_DRIVE_COMPLETE_SEVEN_POINT, TIME_LEFT, TEST_DRIVE_TIMER, MENU_OPEN_MODEL, RIDE_START_TIME, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    allScanCheckpoint: '',
    scanCheckPointList: '',
    gptScanCheckPointResponce: '',
    gptErrorToast: false,
    gptMessageToast: false,
    allCheckPointScanToast: false,
    testDriveComplect: false,
    testDriveComplectSevenPoint: false,
    timeLeft: '',
    testDriveTimer: '00:00',
    modalIsOpen: false,
    rideStartTime: '',
    testDriveRideId: ''
}

export const testDriveReducer = (state = initialState, action) => {
    switch (action.type) {
        case ALL_SCAN_CHECKPOINT_LIST:
            return {
                ...state,
                allScanCheckpoint: action.payload
            };
        case SCAN_CHECKPOINT_LIST:
            return {
                ...state,
                scanCheckPointList: action.payload
            };
        case GPT_SCAN_CHECKPOINT_RESPONECE:
            return {
                ...state,
                gptScanCheckPointResponce: action.payload
            };
        case GPT_ERROR_TOAST:
            return {
                ...state,
                gptErrorToast: action.payload
            };
        case GPT_MESSAGE_TOAST:
            return {
                ...state,
                gptMessageToast: action.payload
            };
        case ALL_SCAN_CHECK_POINT_TOAST:
            return {
                ...state,
                allCheckPointScanToast: action.payload
            };
        case TEST_DRIVE_COMPLECT:
            return {
                ...state,
                testDriveComplect: action.payload
            };
        case TEST_DRIVE_COMPLETE_SEVEN_POINT:
            return {
                ...state,
                testDriveComplectSevenPoint: action.payload
            };
        case TIME_LEFT:
            return {
                ...state,
                timeLeft: action.payload
            };
        case TEST_DRIVE_TIMER:
            return {
                ...state,
                testDriveTimer: action.payload
            };
        case MENU_OPEN_MODEL:
            return {
                ...state,
                modalIsOpen: action.payload
            };
        case RIDE_START_TIME:
            return {
                ...state,
                rideStartTime: action.payload
            };
        case TESTDRIVE_RIDE_ID:
            return {
                ...state,
                testDriveRideId: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}